import { Component, ViewChild, AfterContentChecked, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { config } from "../../../config/index";
import { MatDialogRef, MatDialog } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var Stripe: any;

import { SubscriptionService } from "./subscription.service";
import { SessionStorageService } from '../shared/services/session-storage.service';
import { SnackbarService } from "../shared/services/snackbar.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";
import { FailurePopupComponent } from '../shared/components/failure-popup/failure-popup.component';
import { SuccessPopupComponent } from '../shared/components/success-popup/success-popup.component';
import { Subscription } from 'rxjs';
import { StripeAddNewPaymentComponent } from '../shared/components/stripe-add-new-payment/stripe-add-new-payment.component';

@Component({
    template: require('./subscription.component.html'),
    styles: [require('./subscription.component.less')],
    providers: [ SubscriptionService, SnackbarService, SessionStorageService],
    preserveWhitespaces: true
})

export class SubscriptionComponent implements OnInit, AfterContentChecked, OnDestroy {
    practiceProfileData: any = { billing_address: {}, subscription: {} };
    locationData: any = [];
    addLocationData: any = [];
    addedLocationCount: number;
    locationUsedCount: number;
    locationFreeCount: number;
    locationFreeArray: any = [];
    locationSetupFee: any;
    countryList: any = [];
    stateList: any = [];
    postCodeRanges: any = [];
    selectedCountry: any;
    selectedState: any;
    isEdit: boolean = false;
    requiredData: boolean = false;
    current_billing_address: any = {};
    current_billing_address_copy: any = {};
    additionalLocations: number;
    isProceedOk: boolean = false;
    loading: boolean = false;
    loadingForPopup: boolean = false;
    existingCards: any = [];
    subscriptionData: any = {};
    subscriptionDataCopy: any = {};
    additionalLocationCard: any ={};
    cardData: any = {};
    isRequiredCard: boolean = false;
    error: boolean;
    defaultCard: any = {};
    selectedCard: any = {};
    defaultCardNumber: any;
    defaultCardDate: any;
    defaultCardBrand: any;
    private package = config.package;
    statementsData: any = [];
    statementFileTotalCount: number = 0;
    isTouchDevice: boolean;
    dialogNewClasses: string;
    loadingBillingAddress: boolean = false;
    payButtonDisabled: boolean = true;
    totalNoOfActiveCard: any;
    paymentTypes: any = [{
        name: 'MONTHLY',
        value: 'monthly'
    },
    {
        name: 'YEARLY',
        value: 'yearly'
    }];
    promocodeError: boolean = false;
    selectPaymentCardClass: string;

    zipFormat: any = /\b\d{5}\b/;
    postalFormat: any = /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
    zipError: boolean;
    stateProvinceLabel = 'STATE';
    paymentCardId: any = null;
    cardDeclined: boolean = false;
    cardComplete: boolean = false;
    cardDeclinedOnPayment: boolean = false;
    currency: any;
    paymentErrorMsg: any;
    apiSubscription: Subscription[] = [];
    cardsApiSubscription: Subscription;
    deleteCardApiSubscription: Subscription;
    statementApiSubscription: Subscription;
    savePracticeApiSubscription: Subscription;
    saveRenewalApiSubscription: Subscription;
    saveSubApiSubscription: Subscription;
    makeDefaultApiSubscription: Subscription;
    addCardApiSubscription: Subscription;
    saveMonthlyAutoRenewalApiSubscription: Subscription;
    additionalLocationPaymentApiSubscription: Subscription;

    card: any;
    cardOption: any;

    submitClicked: boolean;
    disableSubmit: boolean;

    dialogRefRetryPopup: MatDialogRef<FailurePopupComponent>;
    dialogRefSuccessPopup: MatDialogRef<SuccessPopupComponent>;


    @ViewChild('cardInfoPopup', { static: false }) cardInfoPopup: any;
    @ViewChild('confirmSaveAddress', { static: false }) confirmSaveAddress: any;
    @ViewChild('confirmDeletePayment', { static: false }) confirmDeletePayment: any;
    @ViewChild('menubarEvent', { static: false }) menubarEvent: any;
    @ViewChild('notSubscribedPopupEnterprise', { static: false }) notSubscribedPopupEnterprise: any;
    @ViewChild('confirmRenewalPopup', { static: false }) confirmRenewalPopup: any;
    @ViewChild('addLocationConfirmationPopUp', { static: false }) addLocationConfirmationPopUp: any;
    @ViewChild('retryPaymentPopUp', { static: false }) retryPaymentPopUp: any;
    @ViewChild(StripeAddNewPaymentComponent, { static: false }) stripeAddNewPaymentComponent: any;


    constructor(
        private _mdlSnackbarService: SnackbarService,
        public _subscriptionService: SubscriptionService,
        private _router: Router,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _sessionStorageService: SessionStorageService,
        public dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.loading = true;
        this.apiSubscription.push(this._subscriptionService.getPracticeProfileDetails()
            .subscribe(res => this.profileDetailsSuccessHandler(res),
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')));
        this.getCards();
        this.subscriptionData.card = 172;
        this.apiSubscription.push(this._subscriptionService.getStatements()
            .subscribe(res => this.statementsSuccessHandler(res),
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')));
    }

    /**
     * function to save api token for login in localforage.
     * @param  {any} data api token.
     */
    saveToken = async (key: string, data: any) => {
        try {
            if (key === "subscription") {
                await this._sessionStorageService.saveItem(this.package, data);
            }
        }
        catch (error) {
            return error;
        }
    }

    removeCardPopup(cardID: any) {
        this.paymentCardId = cardID;
        this.confirmDeletePayment.show();
    }

    confirmRemoveCard() {
        this.loadingForPopup = true;
        this.confirmDeletePayment.close();
        this.deleteCardApiSubscription?.unsubscribe();
        this.deleteCardApiSubscription = this._subscriptionService.deleteCard(this.paymentCardId)
            .subscribe(res => {
                this.loadingForPopup = false;
                this._mdlSnackbarService.showSnackbar('DELETED', 'success');
                this.getCards();
            },
            error => {
                this.loadingForPopup = false;
                this._mdlSnackbarService.showSnackbar('NOT_DELETED', 'error')
            });
    }

    closeDeletePaymentPopup() {
        this.paymentCardId = null;
        this.confirmDeletePayment.close();
    }

    getCards() {
        this.cardsApiSubscription?.unsubscribe();
        this.cardsApiSubscription = this._subscriptionService.getCards()
            .subscribe(res => this.getCardsSuccessHandler(res),
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'));
    }

    cardSelectionChangeOnLocationPopup() {
        this.cardComplete = false;
        this.cardDeclinedOnPayment = false;
    }

    getCardsSuccessHandler(res: any) {
        let hasDefaultCard = false;
        this.existingCards = res.data;
        this.totalNoOfActiveCard = this.existingCards.length;
        let self = this;
        let cardId: number;

        this.existingCards.forEach((card: any) => {
            if (card.is_primary) {
                hasDefaultCard = true;
                cardId = card.id;
                self.subscriptionData.card = cardId.toString();
                this.defaultCard = card;
                this.defaultCardNumber = card.number;
                this.defaultCardDate = card.exp_month + "/" + card.exp_year;
                this.defaultCardBrand = card.brand;
                this.totalNoOfActiveCard = this.totalNoOfActiveCard - 1;
            } else if (card.is_expired) {
                this.totalNoOfActiveCard = this.totalNoOfActiveCard - 1;
            }
        });
        if (hasDefaultCard === false) {
            this.defaultCard = {};
        }
        
    }

    updateAutoRenewalConfirmationPopup() {
        this.confirmRenewalPopup.show();
    }

    updateAutoRenewal() {
        this.confirmRenewalPopup.close();
        this.saveMonthlyAutoRenewalApiSubscription?.unsubscribe();
        let autoSubscriptionDetails = {"enable": this.practiceProfileData.enable_auto_subscription};
        this.saveMonthlyAutoRenewalApiSubscription = this._subscriptionService.saveMonthlyAutoRewal(autoSubscriptionDetails)
            .subscribe((res: any) => this._mdlSnackbarService.showSnackbar('AUTO_RENEWAL_UPDATED', 'success'),
            (error: any) => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                this.practiceProfileData.enable_auto_subscription = !this.practiceProfileData.enable_auto_subscription;
            });
    }

    closeRenewalPopup() {
        this.practiceProfileData.enable_auto_subscription = !this.practiceProfileData.enable_auto_subscription;
        this.confirmRenewalPopup.close();
    }


    updateCard(card: any) {
        this.selectedCard = card;
    }

    updateadditionalLocationCard() {
        this.cardOption = 'default_card';
    }

    hoverCard($event: any, index: any) {
        if ($event.type === 'mouseover') {
            document.getElementById("delete"+ index)?.classList.add("show-delete");
        } else if ($event.type === 'mouseout') {
            document.getElementById("delete"+ index)?.classList.remove("show-delete");
        }
    }

    showAddCard() {
        this.subscriptionData.card = 'new_card';
    }

    makeAsDefaultCard() {
        this.loadingForPopup = true;
        this.makeDefaultApiSubscription?.unsubscribe();
        if(!this.selectedCard.id) {
            this.selectedCard.id = this.defaultCard.id;
        }
        this.makeDefaultApiSubscription = this._subscriptionService.updateCard({ id: this.selectedCard.id })
            .subscribe(res => {
                this.defaultCard = this.selectedCard;
                this.makeAsDefaultCardSuccessHandler(res)},
                error => this.addCardsErrorHandler(error));
    }

    makeAsDefaultCardSuccessHandler(res: any) {
        this.loadingForPopup = false;
        this._mdlSnackbarService.showSnackbar('DEFAULT_CARD_UPDATED', 'success');
        this.getCards();
        this.cardInfoPopup.close();
    }

    /*
    * Method to report errors on payment
    *
    **/
    reportError(message: any) {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar(message, 'error');
        return false;
    }

    /*
    * Method to add a new card or select existing card for additional location payment
    *
    **/

    additionalLocationSaveCard () {
        this.submitClicked = true;
        if(this.cardOption === 'new_card') {
            this.cardDeclinedOnPayment = false;
            this.stripeAddNewPaymentComponent.setUpPaymentIntent('locationPayment');
        } else {
            this.loadingForPopup = true;
            this.additionalLocationPayment({ payment_method_id: this.additionalLocationCard});
        }
    }

    /*
    * Method for payment for additional location payment using
    *
    **/

    additionalLocationPayment(postData: any) {
        this.loadingForPopup = true;
        this.additionalLocationPaymentApiSubscription?.unsubscribe();
        
        this.additionalLocationPaymentApiSubscription = this._subscriptionService.addLocations(postData)
            .subscribe((res:any) => {
                this.additionalLocationPaymentSucessHandler();
            },
                error => this.additionalLocationPaymentErrorHandler(error));
    }

    additionalLocationPaymentSucessHandler() {
        this.loadingForPopup = false;
        this.closeRetryPaymentPopUp();
        this.dialogRefSuccessPopupOpen();
    }

    additionalLocationPaymentErrorHandler(error:any) {
        this.loadingForPopup = false;
        if (this.cardOption !== 'new_card') {
            this.additionalLocationCard = '';
        } else if (error?.error_code == 322) {
            this.cardDeclinedOnPayment = true;
        }
        this.payButtonDisabled = true;
        this._mdlSnackbarService.showSnackbar(error.message, 'error');
    }

    dialogRefSuccessPopupOpen() {
        this.loading = false;
        this.dialogRefSuccessPopup = this.dialog.open(SuccessPopupComponent, {
            disableClose: false,
            panelClass: 'payment-success-popup',
        });

        this.dialogRefSuccessPopup.afterClosed().subscribe(result => {
            this.loading = true;
            location.reload();
        });

        setTimeout(() => {
            this.loading = true;
            this.dialogRefSuccessPopup.close();
            location.reload();
        }, 3000);
    }

    dialogRefRetryPopupOpen(error: any) {
        this.loading = false;
        this.dialogRefRetryPopup = this.dialog.open(FailurePopupComponent, {
            disableClose: true,
            panelClass: 'payment-success-popup',
            data: {
                errorMsg: error.message
            },
        });

        this.dialogRefRetryPopup.componentInstance.newItemEvent.subscribe((response: any) => {
            if (response === 'open_cards_popup') {
                if (this.totalNoOfActiveCard <= 0) {
                    this.cardOption = 'new_card';
                    this.cardDeclinedOnPayment = false;
                    this.cardOptionChange();
                }
                this.additionalLocationCard = this.subscriptionData.card;
                this.retryPaymentPopUp.show()
            }
        });
    }

    cardOptionChange() {
        this.payButtonDisabled = false;
    }

    onCardSave(data: any) {
        switch (data.trigger) {
            case 'addCard':
                this.addCardsSuccessHandler();
                break;
            case 'locationPayment':
                const postData = { payment_method_id: data.res.id, delete_if_failed: data.delete_if_failed };
                this.additionalLocationPayment(postData);
                break;
        }
    }

    onCardSaveError(){
        this.loadingForPopup = false;
        this.cardDeclined = true;
    }

    onCardValidation(event: any) {
        if(event) {
            this.loadingForPopup = false;
        }
    }

    onPaymentIntentStart() {
        this.loadingForPopup = true;
    }

    saveCard() {
        this.stripeAddNewPaymentComponent.setUpPaymentIntent('addCard');
    }

    addCardsSuccessHandler() {
        this.subscriptionData.card = {};
        this.loadingForPopup = false;
        this._mdlSnackbarService.showSnackbar('CARD_ADDED_SUCCESSFULLY', 'success');
        this.cardData = {};
        this.getCards();
    }

    addCardsErrorHandler(error: any) {
        this.loadingForPopup = false;
        this.cardDeclined = true;
        this._mdlSnackbarService.showSnackbar(error.message, 'error');
    }

    closeCardPopup() {
        this.cardInfoPopup.close();
        this.isRequiredCard = false;
        this.cardData = {};
        this.cardDeclined = false;
        if (this.defaultCard && Object.keys(this.defaultCard).length !== 0) {
            this.subscriptionData.card = this.defaultCard?.id?.toString();
        } else {
            this.subscriptionData.card = '';
        }
    }

    cancelAddCardPopup() {
        this.isRequiredCard = false;
        this.cardData = {};
        this.cardDeclined = false;

        if (this.defaultCard && Object.keys(this.defaultCard).length !== 0) {
            this.subscriptionData.card = this.defaultCard?.id?.toString();
        } else {
            if (this.stripeAddNewPaymentComponent) {
                this.stripeAddNewPaymentComponent.cardData.name = '';
                this.stripeAddNewPaymentComponent.cardError = {
                    cardNumber: false,
                    cardExpiry: false,
                    cardCvc: false
                }
                this.stripeAddNewPaymentComponent.cardErrorMessages = {
                    cardNumber: '',
                    cardExpiry: '',
                    cardCvc: ''
                };
                this.stripeAddNewPaymentComponent.cardComplete = {
                    cardNumber: false,
                    cardExpiry: false,
                    cardCvc: false
                };
                this.stripeAddNewPaymentComponent.nameError = false;
                this.stripeAddNewPaymentComponent.errorElement.textContent = null;
            }
            this.subscriptionData.card = '';
            this.submitClicked = false;
            this.cardInfoPopup.close();
        }
    }

    closeSaveAddressPopup() {
        this.confirmSaveAddress.close();
    }

    editLocationDetail(location: any) {
        this._sessionStorageService.saveItem('editLocation', location);
        this._router.navigate(['pa-settings/geography-settings']);
    }

    addLocationDetail() {
        this._sessionStorageService.saveItem('editLocation', null);
        this._router.navigate(['pa-settings/geography-settings']);
    }

    addLocationConfirmationPopUpShow() {
        if (this.practiceProfileData.subscription.package.name !== 'ENTERPRISE') {
            this.addLocationConfirmationPopUp.show();
        }
        else {
            this.notSubscribedPopupEnterprise.show();
        }
    }

    addLocationConfirmationPopUpClose() {
        this.addLocationConfirmationPopUp.close();
    }

    locationDetailsSuccessHandler(res: any) {
        this.locationData = res.data;
        this.locationSetupFee = res.extra?.location_setup_fee;
        this.addedLocationCount = res.count;
        for (let i = 0; i < this.locationUsedCount - res.count; ++i) {
            this.addLocationData.push({});
        }
    }

    profileDetailsSuccessHandler(res: any) {
        this.practiceProfileData = res.data;
        this.practiceProfileData.renewaldate = this.addOneDay(this.practiceProfileData.subscription.valid_to);
        this.subscriptionData.subscription_term = this.practiceProfileData.subscription.subscription_term;

        this.subscriptionData.no_of_locations = this.practiceProfileData.subscription.no_of_locations;
        this.subscriptionData.package_name = res.data.subscription.package.name;
        this.saveToken("subscription", { package: this.subscriptionData.package_name }).then(() => {
            this.menubarEvent.readPackage();
        });
        this.subscriptionData.payment_type = this.practiceProfileData.subscription.payment_type;
        this.locationUsedCount = this.practiceProfileData.subscription.no_of_locations;
        if (this.practiceProfileData.subscription.package.name === 'ENTERPRISE') {
            this.practiceProfileData.subscription.package.to_locations = this.practiceProfileData.subscription.no_of_locations;
            this.locationFreeCount = this.practiceProfileData.subscription.package.to_locations - this.locationUsedCount;
            this.current_billing_address = res.data.billing_address;
            this.current_billing_address_copy = JSON.parse(JSON.stringify(this.current_billing_address));

        }
        else {
            this.locationFreeCount = this.practiceProfileData.subscription.package.to_locations - this.locationUsedCount;
            for (let i = this.locationFreeCount; i > 0; --i) {
                this.locationFreeArray.push(i);
            }
            this.practiceProfileData.additionalLocations = this.locationFreeArray[0];
            this.current_billing_address = res.data.billing_address;
            this.current_billing_address_copy = JSON.parse(JSON.stringify(this.current_billing_address));
        }

        this.apiSubscription.push(this._subscriptionService.getPracticeLocationDetails()
            .subscribe(res => this.locationDetailsSuccessHandler(res),
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')));
        this.getCities();
    }

    fetchStatement(id: any, download: boolean) {
        this.loading = true;
        this.statementApiSubscription?.unsubscribe();
        this.statementApiSubscription = this._subscriptionService.getStatementPdf(id)
            .subscribe(res => {
                this.loading = false;
                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(res, "Statement-" + id + "-" + new Date().getTime() + ".pdf");
                } else {
                    var blob = res;
                    var link = document.createElement('a');
                    var binaryData: any = [];
                    binaryData.push(blob);
                    link.href = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
                    if (download) {
                        link.download = "Statement-" + id + "-" + new Date().getTime() + ".pdf";
                        // append the link to the document body
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                    } else {
                        window.open(link.href, '_blank');
                    }
                }
            },
                error => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    addOneDay(tt: any) {
        let date = new Date(tt);
        let newdate = new Date(date);
        newdate.setDate(newdate.getDate() + 1);
        return newdate;
    }

    /** To Fetch Location details **/
    getCities = () => {
        this.apiSubscription.push(this._subscriptionService.getCities()
            .subscribe((res: any) => {
                this.getCitiesSuccessHandler(res.data);
            },
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error')));
    }

    getCitiesSuccessHandler(continents: any) {
        continents.forEach((continent: any) => {
            continent.countries.forEach((country: any) => {
                this.countryList.push(country);
            });
        });
        this.countryList.forEach((country: any) => {
            if (country.id === this.practiceProfileData.billing_address.country_id) {
                this.stateList = country.states;
                this.selectedCountry = country;
                this.setStateLabel();
            }
        });
        this.stateList.forEach((state: any) => {
            if (state.id === this.practiceProfileData.billing_address.state_id) {
                this.selectedState = state;
            }
        });
        this.stateSelected();
        this.loading = false;
    }

    cancel() {
        this.isProceedOk = false;
    }

    countrySelected() {
        this.current_billing_address.country_id = this.selectedCountry.id;
        this.stateList = null;
        this.current_billing_address.state_id = null;
        this.current_billing_address.zip = '';
        this.postCodeRanges = [];
        this.zipError = false;
        this.setStateLabel();
        this.countryList.forEach((country: any) => {
            if (country.id === this.current_billing_address.country_id) {
                this.stateList = country.states;
            }
        })
    }

    setStateLabel() {
        switch (this.selectedCountry.name.toLowerCase()) {
            case 'usa':
                this.stateProvinceLabel = 'STATE';
                break;
            case 'canada':
                this.stateProvinceLabel = 'PROVINCE';
                break;
            case 'australia':
                this.stateProvinceLabel = 'STATE_TERRITORY';
                break;
            default:
                this.stateProvinceLabel = 'STATE_PROVINCE';
                break;
        }
    }

    stateSelected() {
        this.stateList.forEach((state: any) => {
            if (state.id === this.practiceProfileData.billing_address.state_id) {
                this.postCodeRanges = state.zip_code_ranges;
                this.selectedState = state;
            }
        });
    }

    editBillingAddress() {
        this.isEdit = true;
    }

    saveBillingAddressConfirmationPopup() {
        if (this.validateBillingAddress()) {
            this.confirmSaveAddress.show();
        }
    }

    saveBillingAddress() {
        this.confirmSaveAddress.close();
        this.requiredData = true;
        this.loadingBillingAddress = true;
        if (this.practiceProfileData.billing_address.street_address2 === '') {
            this.practiceProfileData.billing_address.street_address2 = null;
        }
        this.practiceProfileData.billing_address = JSON.parse(JSON.stringify(this.current_billing_address));
        this.savePracticeApiSubscription?.unsubscribe();
        this.savePracticeApiSubscription = this._subscriptionService.savePractice(this.practiceProfileData)
            .subscribe((res: any) => this.saveBillingAddressSuccess(res),
                (error: any) => this.saveBillingAddressError(error));
    }

    saveBillingAddressSuccess(res: any) {
        this.loadingBillingAddress = false;
        this.current_billing_address_copy = JSON.parse(JSON.stringify(this.current_billing_address));
        this.isEdit = false;
        this._mdlSnackbarService.showSnackbar('BILLING_ADDRESS_UPDATED', 'success');
    }

    saveBillingAddressError(error: any) {
        this.loadingBillingAddress = false;
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
    }

    cancelEditBillingAddress() {
        this.zipError = false;
        this.current_billing_address = JSON.parse(JSON.stringify(this.current_billing_address_copy));
        this.countryList.forEach((country: any) => {
            if (country.id === this.current_billing_address.country_id) {
                this.stateList = country.states;
                this.selectedCountry = country;
                this.setStateLabel();
            }
        });
        this.isEdit = false;
    }

    validateBillingAddress() {
        if (this.current_billing_address.street_address1 && this.current_billing_address.city && 
            this.current_billing_address.zip?.trim().length) {
                if (this.zipError) {
                    this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA', 'error');
                    return false;
                }
            return true;
        }

        this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
        
        return false;
    }

    /*
    * Method to add additional location using default location
    *
    **/

    addLocation() {
        this.loading = true;
        this.apiSubscription.push(this._subscriptionService.addLocations({ payment_method_id: this.defaultCard.id })
            .subscribe(res => this.addLocationsSuccess(res),
                error => this.addLocationsError(error)));
    }

    addLocationsSuccess(res: any) {
        this.addLocationConfirmationPopUpClose();
        this.dialogRefSuccessPopupOpen();
    }

    addLocationsError(error: any) {
        this.addLocationConfirmationPopUp.close();
        this.loading = false;
        this.dialogRefRetryPopupOpen(error);
    }
    
    resetLocationAddPopup() {
        this.payButtonDisabled = true;
        this.additionalLocationCard = '';
    }

    closeRetryPaymentPopUp() {
        this.additionalLocationCard = '';
        this.cardComplete = false;
        this.payButtonDisabled = true;
        this.retryPaymentPopUp.close();
        this.submitClicked = false;
        this.cardDeclined = false;
        this.cardData.name = '';
        // defer so the card/select-source view doesn't swap while the dialog is still fading out (leaveTransitionDuration: 400)
        setTimeout(() => {
            this.cardOption = '';
        }, 400);
    }


    openCardInfo() {
        this.cardInfoPopup.show();
        if (this.existingCards.length === 0) {
            this.subscriptionData.card = 'new_card';
        }
    }

    formatCardNumber(number: any) {
        this.cardData.cardNumber = number.replace(/\s/g, "");
    }
    viewAllStatements() {
        this._router.navigate(['statements']);
    }
    statementsSuccessHandler(res: any) {
        this.statementsData = res.data;
        this.statementFileTotalCount = res.count;
        this.currency = config.currency['USD'];
    }

    zipFormatter(isZip?: boolean) {
        if (!isZip) {
            let cleaned = ('' + this.current_billing_address.zip).replace(/\s/g, ''),
                formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const last = cleaned.substring(3, 6);

            if (cleaned.length > 3) {
                formattedVal = `${zip} ${last}`;
            } else if (cleaned.length > 0) {
                formattedVal = `${zip}`;
            }
            this.zipError = !this.postalFormat.test(formattedVal);

            setTimeout(() => {
                this.current_billing_address.zip = formattedVal;
            });
        } else {
            let cleaned = ('' + this.current_billing_address.zip).replace(/\D/g, '').slice(0, 10);
            this.zipError = !this.zipFormat.test(cleaned);

            setTimeout(() => {
                this.current_billing_address.zip = cleaned;
            });
        }
    }

    breakAt40(text:any = null) {
        if (text && (text.length > 40) && (text.indexOf(' ') <= 0)) {
            return true;
        }
        else {
            return false;
        }
    }

    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
        if (this.isTouchDevice) {
            this.dialogNewClasses = 'new-dialog-container';
            this.selectPaymentCardClass = 'new-dialog-container increase-width'
        } else {
            this.dialogNewClasses = 'new-dialog-container desktop-view';
            this.selectPaymentCardClass = 'new-dialog-container desktop-view increase-width'
        }
    }

    ngOnDestroy() {
        this.closeCardPopup();
        this.cancelAddCardPopup();
        this.closeSaveAddressPopup();
        this.closeDeletePaymentPopup();
        this.notSubscribedPopupEnterprise.close();
        this.confirmRenewalPopup.close();
        this.addLocationConfirmationPopUp.close();
        this.retryPaymentPopUp.close();
        this.dialogRefRetryPopup?.close();
        this.dialogRefSuccessPopup?.close();

        // Unsubscribing all the subscriptions
        this.apiSubscription.forEach(subscription => subscription?.unsubscribe());
        this.cardsApiSubscription?.unsubscribe();
        this.deleteCardApiSubscription?.unsubscribe();
        this.statementApiSubscription?.unsubscribe();
        this.savePracticeApiSubscription?.unsubscribe();
        this.saveRenewalApiSubscription?.unsubscribe();
        this.saveSubApiSubscription?.unsubscribe();
        this.makeDefaultApiSubscription?.unsubscribe();
        this.addCardApiSubscription?.unsubscribe();
        this.saveMonthlyAutoRenewalApiSubscription?.unsubscribe();
    }
}